import { isEqual } from "lodash";
import { createSelectorCreator, defaultMemoize } from "reselect";

import { createStatePropertySelector } from "app/pages/workspace/sales/helpers";
import type { RootState } from "single-spa/store/types";

export const selectSalesIntelligenceState = createStatePropertySelector((root: RootState) => root.salesIntelligence);

export const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);
